var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_560_484",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_560_484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 19.8333C14.3306 19.8333 14.6076 19.7215 14.8313 19.4979C15.0549 19.2743 15.1667 18.9972 15.1667 18.6667C15.1667 18.3361 15.0549 18.059 14.8313 17.8354C14.6076 17.6118 14.3306 17.5 14 17.5C13.6694 17.5 13.3924 17.6118 13.1687 17.8354C12.9451 18.059 12.8333 18.3361 12.8333 18.6667C12.8333 18.9972 12.9451 19.2743 13.1687 19.4979C13.3924 19.7215 13.6694 19.8333 14 19.8333ZM12.8333 15.1667H15.1667V8.16667H12.8333V15.1667ZM9.625 24.5L3.5 18.375V9.625L9.625 3.5H18.375L24.5 9.625V18.375L18.375 24.5H9.625Z",
    fill: "#C73C2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.f7e121a70470fb6885eaedf4dfdf99e6.svg";
export { ForwardRef as ReactComponent };